<template>
  <sp-rating
    v-preserve-properties:rating="score"
    v-preserve-properties:count="rating.count"
    class="sp-finder-result-ratings"
    part="base"
    :url="url"
    :info-url="infoUrl"
    :info-icon="infoIcon"
    fraction-digits="1"
    :showcount="showCount"
    target="_blank"
  ></sp-rating>
</template>

<script setup>
import { computed } from "vue";
import { vPreserveProperties } from "#ce/utils/property-bindings";

const props = defineProps({
  /**
   * Shows the number of ratings under the stars.
   *
   * @type {Boolean}
   */
  showCount: {
    type: Boolean,
    default: false,
  },
  /**
   * The result's rating data: `score`, `count`, `rated`, `url`, `info_url`, `info_icon`.
   *
   * @type {Object}
   */
  rating: {
    type: Object,
    default: () => ({}),
  },
});

const score = computed(() => (props.rating.rated ? Number(props.rating.score) : undefined));
const url = computed(() => props.rating.url || undefined);
const infoUrl = computed(() => props.rating.info_url || undefined);
const infoIcon = computed(() => props.rating.info_icon || undefined);
</script>

<style>
/* A finder rating takes the deployment's rating tokens, overridden by its own `finder-result-rating` ones. */
:host {
  --finder-rating-font-family: var(--sp-comp-finder-result-rating-font-family, var(--sp-comp-rating-font-family));
  --finder-rating-font-size: var(--sp-comp-finder-result-rating-font-size, var(--sp-comp-rating-font-size));
  --finder-rating-font-size-sm: var(--sp-comp-finder-result-rating-font-size-sm, var(--sp-comp-rating-font-size-sm));
  --finder-rating-font-weight: var(--sp-comp-finder-result-rating-font-weight, var(--sp-comp-rating-font-weight));
  --finder-rating-icon-size: var(--sp-comp-finder-result-rating-icon-size, var(--sp-comp-rating-icon-size));
  --finder-rating-info-icon-color: var(
    --sp-comp-finder-result-rating-info-icon-color,
    var(--sp-comp-rating-info-icon-color)
  );
  --finder-rating-horizontal-spacing: var(
    --sp-comp-finder-result-rating-horizontal-spacing,
    var(--sp-comp-rating-horizontal-spacing)
  );
  --finder-rating-horizontal-spacing-end: var(
    --sp-comp-finder-result-rating-horizontal-spacing-end,
    var(--sp-comp-rating-horizontal-spacing-end)
  );

  display: block;
}
</style>

<style scoped>
.sp-finder-result-ratings {
  --sp-comp-rating-font-family: var(--finder-rating-font-family);
  --sp-comp-rating-font-size: var(--finder-rating-font-size);
  --sp-comp-rating-font-size-sm: var(--finder-rating-font-size-sm);
  --sp-comp-rating-font-weight: var(--finder-rating-font-weight);
  --sp-comp-rating-icon-size: var(--finder-rating-icon-size);
  --sp-comp-rating-info-icon-color: var(--finder-rating-info-icon-color);
  --sp-comp-rating-horizontal-spacing: var(--finder-rating-horizontal-spacing);
  --sp-comp-rating-horizontal-spacing-end: var(--finder-rating-horizontal-spacing-end);
}
</style>
